import type { ReactNode } from "react";
import type { FormatOptionLabelMeta } from "react-select";

export const OptionLabelWithSource = ({
  label,
  sourceLabel
}: {
  label: ReactNode;
  sourceLabel?: string;
}) => {
  if (!sourceLabel) return <>{label}</>;

  return (
    <span className="block">
      <span className="block text-base text-content-1000">{label}</span>
      <span className="block text-sm text-content-500">{sourceLabel}</span>
    </span>
  );
};

type SourceOption = { label?: ReactNode; sourceLabel?: string };

/** Two lines in the menu, `"<name> (<source>)"` once collapsed (BF-437). */
export const formatOptionLabelWithSource = (
  option: unknown,
  meta: FormatOptionLabelMeta<unknown>
): ReactNode => {
  const { label, sourceLabel } = (option ?? {}) as SourceOption;

  if (!sourceLabel) return label;

  if (meta.context === "value")
    return typeof label === "string" ? `${label} (${sourceLabel})` : label;

  return <OptionLabelWithSource label={label} sourceLabel={sourceLabel} />;
};
